import wixLocation from 'wix-location';
import wixData from 'wix-data';
import wixWindow from 'wix-window';


const createHtml = (text, url, extraStyle) => `<h2 style="font-size:15px"><span style="font-size:15px"><span style="font-family:wfont_311dce_37a69b3a7ca14f258c3442f95b081dd3,wf_37a69b3a7ca14f258c3442f95,orig_helvetica_neue_w_01_55_roman;border-bottom-width: 1px;border-bottom-style: solid;padding-bottom: 3px;${extraStyle}"><a href="${url}" target="_self">${text}</span></span></a></h2>`;
const regularHtml = (text, url) => createHtml(text, url, '');
const hoverHtml = (text, url) => createHtml(text, url, 'color: #0067ff;');

$w.onReady(function () {

	createDropDownValues()

	let formFactor = wixWindow.formFactor;
	if (formFactor !== "Mobile") {
		$w('#group1').hide();
	}

	$w('#newsRepeater').onItemReady(($item, itemData, index) => {
		$item("#text51").text = textShortening(itemData)
		const text1 = $item('#itemBtnLabel');
		text1.html = regularHtml(text1.text, itemData.url);

		$item('#itemBtn').onClick(() => {
			$w('#html1').postMessage(itemData.url)
		})

		$item('#itemBtn').onMouseIn(() => {
			text1.html = hoverHtml(text1.text, itemData.url);
		});

		$item('#itemBtn').onMouseOut(() => {
			text1.html = regularHtml(text1.text, itemData.url);

		});
	});

	$w('#loadMoreButton').onClick(() => {
		$w("#newsDataset").onReady(() => {
			$w("#newsDataset").loadMore()
		});
	})
});

export function searchBar_keyPress(event) {
	if (!$w('#searchBar').value) {
		$w('#newsDataset').setFilter(wixData.filter())
	} else {
		$w("#newsDataset").setFilter(wixData.filter()
			.contains("subTitle", $w("#searchBar").value)
			.or(wixData.filter()
				.contains("title", $w('#searchBar').value)))
	}
}

export function yearsDropdown_change(event) {
	if ($w('#yearsDropdown').value === "All Years") {
		$w('#newsDataset').setFilter(wixData.filter())
	} else {
		$w('#newsDataset').setFilter(wixData.filter()
			.eq("year", $w('#yearsDropdown').value))
	}
}

function textShortening(itemData) {
	let fullText = itemData.title;
	let text2Show
	if (fullText.length >= 85) {
		text2Show = fullText.slice(0, 85) + "..."
		return text2Show;
	}
	return fullText;
}

function createDropDownValues() {
	wixData.query("News")
		.limit(1000)
		.find()
		.then(results => {
			let dropDownValues = [];
			results.items.forEach(item => {
				if (dropDownValues.indexOf(item.year) === -1 && item.year !== undefined) {
					dropDownValues.push(item.year)
				}
			})
			dropDownValues.sort().reverse()
			dropDownValues.unshift('All Years')
			$w("#yearsDropdown").options = dropDownValues.map(item => {
				return { "label": item, "value": item }
			});
		})
}

const slideOptions = {
	direction: 'right',
	duration: 300
};

export function siteSearchIcon_click(event, $w) {
	if ($w('#searchBar').hidden) {
		$w('#searchBar').show('slide', slideOptions);
		setTimeout(() => {
			$w('#searchBar').focus();
		}, 350);
		return;
	}
	$w('#searchBar').hide('slide', slideOptions);
}